import { compose, prop } from 'ramda';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Dialog } from '@ezugi/primitives';

import { useIntl } from '../../../hooks/useIntl';
import { menuActions } from '../../../store/actions';
import { widgetsSelector } from '../../../store/selectors';
import { noVideoClassName } from '../style.css';
import { refreshButton, homeButton } from './buttons';

const { home } = menuActions;

export const noVideoIntlKeys = {
  title: 'messages.video_unavailable_title',
  message: 'messages.video_unavailable_message',
  homeLabel: 'general.home',
  backLabel: 'general.go_back',
  refreshLabel: 'general.refresh',
};

const NoVideo = (props) => {
  const { title, message, homeLabel, backLabel, refreshLabel } = useIntl({ keys: noVideoIntlKeys });

  const dispatch = useDispatch();
  const canGoHome = useSelector(compose(prop('home'), widgetsSelector));

  const requestHome = () => dispatch(home.request());

  return (
    <Dialog
      {...props}
      on={true}
    >
      <Dialog.Wrapper>
        <Dialog.Title>
          {title}
        </Dialog.Title>
        <Dialog.Description dangerouslySetInnerHTML={{ __html: message }} />
        <Dialog.Buttons>
          <Dialog.Button
            {...refreshButton}
            label={refreshLabel}
            className={noVideoClassName}
            onClick={() => location.reload()}
          />
          <Dialog.Button
            {...homeButton}
            label={canGoHome ? homeLabel : backLabel}
            className={noVideoClassName}
            onClick={() => {
              canGoHome ? requestHome() : history.back();
            }}
          />
        </Dialog.Buttons>
      </Dialog.Wrapper>
    </Dialog>
  );
};

export default NoVideo;
